import React from 'react';

// Lo que falló en una operación que terminó a medias. El cartel dice cuántos; acá queda cuáles, hasta la próxima acción.
export default function OperationErrors({ errors, total }) {
    if (!errors || errors.length === 0) return null;
    const count = Math.max(total || 0, errors.length);
    return (
        <div role="alert" aria-label="Errores de la última operación" className="p-3 rounded-lg bg-amber-50 border border-amber-200 text-sm text-amber-800">
            <p className="font-semibold">{count} con error:</p>
            <ul className="mt-1 max-h-40 overflow-y-auto font-mono text-xs space-y-0.5">{errors.map((item, i) => <li key={i} className="break-words">{item}</li>)}</ul>
            {count > errors.length && <p className="mt-1 text-xs">y {count - errors.length} más.</p>}
        </div>
    );
}
